import {Component, OnInit} from '@angular/core';
import {CashBookingService} from "../../../services/cash-booking.service";
import {AlertService} from "../../../services/alert.service";
import {LoaderService} from "../../../services/loader.service";
import {Router} from "@angular/router";
import {Subject} from "rxjs/Rx";
import * as $ from 'jquery';
import {PrintService} from "../../../services/print.service";

@Component({
  selector: 'app-cash-book-list',
  templateUrl: './cash-book-list.component.html',
  styleUrls: ['./cash-book-list.component.css']
})

export class CashBookListComponent implements OnInit {
  private loading = false;
  private cashBookList;
  dtTrigger:Subject<any> = new Subject();
  dtOptions:any = {};
  authWindow = null;

  constructor(private cashBookingService:CashBookingService,
              private alertService:AlertService,
              private printService:PrintService,
              private router:Router,
              private loaderService:LoaderService) {
  }

  ngOnInit() {
    this.loaderService.loading(true);
    this.dtOptions = {
      select: true,
      buttons: [
        'columnsToggle',
        'colvis',
        'copy',
        'print',
        'excel',
        {
          text: 'Some button',
          key: '1',
          action: function (e, dt, node, config) {
            alert('Button activated');
          }
        }
      ]
    };

    this
      .cashBookingService
      .list()
      .subscribe(
        data => {
          this.cashBookList = data;
          this.initDataTable()
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.loaderService.loading(false);
        });
  }

  initDataTable() {
    $(document).ready(()=> {
      var table:any = $('table');
      table.dataTable();
      this.loaderService.loading(false);
    })
  }

  goToCashBookingDetails(id:number) {
    this.router.navigate(['/cash_booking', id]);
  }

  print() {
    this.printService.generate_pdf_file()
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/cash-book/cash-book-list/cash-book-list.component.ts